"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LoyaltyClient = void 0;

var _http = require("@tajawal/web-core-sdk-v2/lib/services/http.service");

var _constants = require("../constants");

var LoyaltyClient = {
  calculateFursanBulkRewards: function calculateFursanBulkRewards(payload) {
    var requestId = 'CALCULATE_FURSAN_REWARD_BULK';
    var endPoint = _constants.ENDPOINTS.CALCULATE_REWARD_BULK;
    return _http.$http.post(requestId, endPoint, {
      data: payload
    }).then(function (_ref) {
      var data = _ref.data;
      return data;
    });
  },
  calculateFursanRewards: function calculateFursanRewards(payload) {
    var requestId = 'CALCULATE_FURSAN_REWARD';
    var endPoint = _constants.ENDPOINTS.CALCULATE_REWARD;
    return _http.$http.post(requestId, endPoint, {
      data: payload
    }).then(function (_ref2) {
      var data = _ref2.data;
      return data;
    });
  },
  calculateQitafBulkRewards: function calculateQitafBulkRewards(payload) {
    var requestId = 'CALCULATE_QITAF_REWARD_BULK';
    var endPoint = _constants.ENDPOINTS.CALCULATE_REWARD_BULK;
    return _http.$http.post(requestId, endPoint, {
      data: payload
    }).then(function (_ref3) {
      var data = _ref3.data;
      return data;
    });
  },
  calculateQitafRewards: function calculateQitafRewards(payload) {
    var requestId = 'CALCULATE_QITAF_REWARD';
    var endPoint = _constants.ENDPOINTS.CALCULATE_REWARD;
    return _http.$http.post(requestId, endPoint, {
      data: payload
    }).then(function (_ref4) {
      var data = _ref4.data;
      return data;
    });
  },
  calculateMokafaaRewards: function calculateMokafaaRewards(payload) {
    var requestId = 'CALCULATE_MOKAFA_REWARD';
    var endPoint = _constants.ENDPOINTS.CALCULATE_REWARD;
    return _http.$http.post(requestId, endPoint, {
      data: payload
    }).then(function (_ref5) {
      var data = _ref5.data;
      return data;
    });
  },
  validateFursanPhoneNumber: function validateFursanPhoneNumber(payload) {
    var requestId = 'VALIDATE_FURSAN_IDENTIFIER';
    var endPoint = _constants.ENDPOINTS.VALIDATE_IDENTIFIER;
    return _http.$http.post(requestId, endPoint, {
      data: payload
    }).then(function (_ref6) {
      var data = _ref6.data;
      return data;
    });
  },
  validateQitafPhoneNumber: function validateQitafPhoneNumber(payload) {
    var requestId = 'VALIDATE_QITAF_IDENTIFIER';
    var endPoint = _constants.ENDPOINTS.VALIDATE_IDENTIFIER;
    return _http.$http.post(requestId, endPoint, {
      data: payload
    }).then(function (_ref7) {
      var data = _ref7.data;
      return data;
    });
  },
  validateMokafaaPhoneNumber: function validateMokafaaPhoneNumber(payload) {
    var requestId = 'VALIDATE_MOKAFAA_IDENTIFIER';
    var endPoint = _constants.ENDPOINTS.VALIDATE_IDENTIFIER;
    return _http.$http.post(requestId, endPoint, {
      data: payload
    }).then(function (_ref8) {
      var data = _ref8.data;
      return data;
    });
  },
  initQitafRedeem: function initQitafRedeem(payload) {
    var requestId = 'QITAF_INIT_REDEEM';
    var endPoint = _constants.ENDPOINTS.QITAF_INIT_REDEEM;
    return _http.$http.post(requestId, endPoint, {
      data: payload
    }).then(function (_ref9) {
      var data = _ref9.data;
      return data;
    });
  },
  calculateWalletMaxBurn: function calculateWalletMaxBurn(payload) {
    var requestId = 'CALCULATE_WALLET_MAX_BURN';
    var endpoint = _constants.ENDPOINTS.LOYALTY_MAX_BURN;
    return _http.$http.post(requestId, endpoint, {
      data: payload
    }).then(function (_ref10) {
      var data = _ref10.data;
      return data;
    });
  },
  checkWalletBalance: function checkWalletBalance(payload) {
    var requestId = 'CHECK_WALLET_BALANCE';
    var endpoint = _constants.ENDPOINTS.LOYALTY_CHECK_BALANCE;
    return _http.$http.post(requestId, endpoint, {
      data: payload
    }).then(function (_ref11) {
      var data = _ref11.data;
      return data;
    });
  },
  calculateWalletRewards: function calculateWalletRewards(payload) {
    var requestId = 'CALCULATE_WALLET_REWARD';
    var endpoint = _constants.ENDPOINTS.CALCULATE_REWARD;
    return _http.$http.post(requestId, endpoint, {
      data: payload
    }).then(function (_ref12) {
      var data = _ref12.data;
      return data;
    });
  }
};
exports.LoyaltyClient = LoyaltyClient;